module.exports = __webpack_public_path__ + "static/media/security-hint.77005fd3.png";